import React from 'react';
import axios from 'axios';

import {
  requestCallback,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import Modal from './Modal';

const ModalDeleteImage = ({
  klassName = 'Table__controls__a Table__controls__a--x-sq',
  hideText = false,
  id = null,
  resourceType,
  imageType,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onDelete = () => {
    requestCallback(axios.get(`/${gon.currentProvider}/api/${resourceType}s/${id}/remove_${imageType}`))
  }

  return (
    <React.Fragment>
      <a
        className={klassName}
        onClick={() => {
          modalSet(true)
        }}
      >
        {!hideText && 'Remove'}
      </a>

      <Modal
        isActive={modal}
        onToggleModal={() => {
          modalSet(false)
        }}
      >
        <h3 className='Modal__h3'>Delete {resourceType} {id} {imageType}</h3>

        <div className='Modal__p__wrapper'>
          <p className='Modal__p'>Are you sure you want to delete this {resourceType} {imageType}? This action cannot undone.</p>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={() => {
              modalSet(false)
            }}
          >
            Cancel
          </a>

          <button
            className='Button Button--blue'
            onClick={onDelete}
            ref={$submitButton}
          >
            Submit
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default ModalDeleteImage;
